import { render } from "./Change-Password-Expired-Link.vue?vue&type=template&id=f7589072&scoped=true"
import script from "./Change-Password-Expired-Link.vue?vue&type=script&lang=js"
export * from "./Change-Password-Expired-Link.vue?vue&type=script&lang=js"

import "./Change-Password-Expired-Link.vue?vue&type=style&index=0&id=f7589072&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7589072"]])

export default __exports__